import * as ReactDOM from 'react-dom';
import * as React from 'react';
import { Button, BUTTON_TYPE } from '@bepure/tarkin';

interface Props {
    buttonText: string;
    buttonType: BUTTON_TYPE;
    link?: string;
    otherClasses?: string;
    onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
}

class PrePurchaseButton extends React.PureComponent<Props> {
    public render() {
        return (
            <React.Fragment>
                <Button
                    text={this.props.buttonText}
                    ariaLabel={this.props.buttonText}
                    button_type={this.props.buttonType}
                    onClick={this.onClick}
                    otherClasses={this.props.otherClasses}
                />
            </React.Fragment>
        );
    }

    public onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const {link, onClick} = this.props;

        if (onClick) {
            return onClick(event);
        } else if (link) {
            window.location.assign(link);
        }

        return('No onClick function or link is provided');
    }
}

export const renderPrePurchaseButton = (buttonType: BUTTON_TYPE,
                                        buttonText: string,
                                        buttonClasses: string = '',
                                        link?: string,
                                        onClickFunction?: (event: React.MouseEvent<HTMLElement>) => void,
                                        ): React.ReactNode => {
    return (
        <PrePurchaseButton
            buttonText={buttonText}
            buttonType={buttonType}
            otherClasses={buttonClasses}
            link={link}
            onClick={onClickFunction}
        />
    );
};

export const renderPrePurchaseButtonToHtml = () => {
    const prePurchaseElements: Element[] = Array.from(document.getElementsByClassName('pre-purchase-button'));

    prePurchaseElements.forEach(element => {
        const buttonType = element.classList.contains('button-secondary') ? BUTTON_TYPE.SECONDARY : BUTTON_TYPE.PRIMARY;

        ReactDOM.render(
            <PrePurchaseButton
                buttonText={(element as HTMLElement).innerText}
                buttonType={buttonType}
                link={(element as HTMLElement).dataset.link}
                otherClasses={Array.prototype.join.call(element.classList, ' ')}
            />,
            element,
        );
    });
};
